import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {
  MarketingProfile,
  MarketingProfileSettings,
  GetMarketingProfileInput,
  UpdateMarketingProfileInput,
  QueryMarketingProfileArgs,
  QueryMarketingProfileSettingsArgs,
  MutationUpdateMarketingProfileArgs,
  MarketingBusinessProfileSettingsInput,
  MarketingBusinessProfile
} from "@irati/types/ops"

import getMarketingProfile from "./queries/marketingProfile"
import getMarketingProfileSettings from "./queries/marketingProfileSettings"
import updateMarketingProfile from "./mutations/updateMarketingProfile"
import updateMarketingBusinessProfileMutation, {updateMarketingBusinessProfileKey} from "./mutations/updateMarketingBusinessProfile"

class Marketing extends PBService {
  async getProfile(data: GetMarketingProfileInput, options: QueryOptions = {}): Promise<MarketingProfile> {
    const variables: QueryMarketingProfileArgs = {data}
    const res = await client.query({...options, query: getMarketingProfile, variables})

    return res.data.marketingProfile
  }

  async getProfileSettings(userId: string): Promise<MarketingProfileSettings> {
    const variables: QueryMarketingProfileSettingsArgs = {userId}
    const {data} = await client.query({query: getMarketingProfileSettings, variables})

    return data.marketingProfileSettings
  }

  async updateProfile(data: UpdateMarketingProfileInput): Promise<MarketingProfile> {
    const variables: MutationUpdateMarketingProfileArgs = {data}
    const res = await client.mutate({mutation: updateMarketingProfile, variables})

    return res.data.updateMarketingProfile
  }

  async updateMarketingBusinessProfile(settings: MarketingBusinessProfileSettingsInput): Promise<MarketingBusinessProfile> {
    const res = await client.mutate({mutation: updateMarketingBusinessProfileMutation, variables: {settings}})

    return res.data[updateMarketingBusinessProfileKey]
  }
}

export default new Marketing({errorHandlers: []})
